import getAuthHeaders from "./authHeaders";
export default async function fetchSearch(
  term: string,
  userId: string,
  apiAddress: string,
  signal?: AbortSignal
) {
  const link = `${apiAddress}/search_chats`;
  const body = {
    term,
    userId
  }

  const response = await fetch(link, {
    method: 'POST',
    headers: await getAuthHeaders({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(body),
    signal, // Pass abort signal to allow cancellation
  })

  return response.json()
}
